<template>
  <div class="error-container">
    <div class="error-content">
      <div class="error-icon">⚠️</div>
      <h2 class="error-title">{{ t('product.error.title') }}</h2>
      <p class="error-message">{{ message }}</p>
      <p class="error-subtitle">{{ t('product.error.subtitle') }}</p>
      
      <button @click="retry" class="error-button">
        {{ t('product.error.btn_retry') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { useLanguage } from '@/composables/useLanguage'

const { t } = useLanguage()

defineProps({
  message: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['retry'])

const retry = () => {
  emit('retry')
}
</script>

<style scoped>
.error-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: 40px 20px;
  background-color: #f5f5f5;
}

.error-content {
  text-align: center;
  max-width: 500px;
}

.error-icon {
  font-size: 64px;
  margin-bottom: 20px;
}

.error-title {
  font-size: 28px;
  color: var(--dark-teal);
  margin-bottom: 16px;
  font-weight: 700;
}

.error-message {
  font-size: 16px;
  color: #555;
  margin-bottom: 8px;
  line-height: 1.6;
}

.error-subtitle {
  font-size: 14px;
  color: #888;
  margin-bottom: 30px;
}

.error-button {
  padding: 12px 32px;
  background-color: var(--teal);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.error-button:hover {
  background-color: var(--dark-teal);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(44, 188, 196, 0.3);
}

.error-button:active {
  transform: translateY(0);
}

@media (max-width: 768px) {
  .error-container {
    min-height: 300px;
  }

  .error-icon {
    font-size: 48px;
  }

  .error-title {
    font-size: 22px;
  }

  .error-message {
    font-size: 14px;
  }
}
</style>
